import { useLocale, type Language } from './LocaleContext'

const languages: Array<[Language, string]> = [['pt', 'Português'], ['en', 'English'], ['es', 'Español']]

export function LanguageSelector({ compact = false }: { compact?: boolean }) {
  const { language, changeLanguage, t } = useLocale()
  return <label className={`language-selector ${compact ? 'compact' : ''}`}>
    {!compact && <span>{t('language')}</span>}
    <select aria-label={t('language')} value={language} onChange={(event) => changeLanguage(event.target.value as Language)}>
      {languages.map(([value, label]) => <option value={value} key={value}>{label}</option>)}
    </select>
  </label>
}
